// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-patient-match-wrapper {
    padding: 16px;
    max-width: 450px;
    margin: 0 auto;
    line-height: 1.3;
}

.confirm-patient-match-wrapper .logos {
    display: flex;
    column-gap: 10px;
    flex-direction: column;
    padding: 8px 0 14px 0;
}

.confirm-patient-match-wrapper .logo-wrap {
    display: flex;
    align-items: center;
    padding: 3px;
    justify-content: center;
}

.confirm-patient-match-wrapper .logo-wrap img {
    max-height: 34px;
    max-width: 100%;
    width: auto;
}

.confirm-patient-match-wrapper h2 {
    font-weight: 500;
    text-align: center;
    margin: 6px 0;
}

.confirm-patient-match-wrapper .callout {
    padding: 12px;
    text-align: center;
    border-radius: 6px;
    background: var(--ce-orange-5);
    margin-bottom: 20px;
}

.confirm-patient-match-wrapper .patient-info {
    margin-bottom: 10px;
    background: var(--ce-grey-5);
    padding: 12px;
    border-radius: 6px;
}

.confirm-patient-match-wrapper .patient-info .title {
    font-weight: 500;
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    justify-content: space-between;
}

.confirm-patient-match-wrapper .patient-info .title img {
    max-height: 20px;
}

.confirm-patient-match-wrapper .patient-info .details {
    background: #fff;
    padding: 12px;
    border-radius: 6px;
}

.confirm-patient-match-wrapper .patient-info .details > div {
    padding-bottom: 3px;
}

.confirm-patient-match-wrapper .patient-info .details > div:last-of-type {
    padding-bottom: 0;
}

.confirm-patient-match-wrapper .buttons {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
        flex-direction: column;
    align-items: center;
}

.confirm-patient-match-wrapper button {
    height: 44px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    font-weight: 500;
    padding: 4px 12px;
}

.confirm-patient-match-wrapper .confirm-button {
    background: #000;
    color: #fff;
    cursor: pointer;
    min-width: 250px;
    display: flex;
    justify-content: center;
    /*display: table-cell;*/
    /*text-align: center;*/
}

.confirm-patient-match-wrapper .cancel-button {
    margin-bottom: 20px;
    margin-right: 10px;
    border: 0;
    background: transparent;
    cursor: pointer;
}

.confirm-patient-match-wrapper pre {
    padding: 16px;
    font-size: 10px;
    background-color: lightgray;
    border: solid 1px black;
}

.confirm-patient-match-wrapper .modal-container {
    display: inline;
    white-space: nowrap;
    padding-left: 1em;
    padding-right: 1em;
}

.confirm-patient-match-wrapper .modal-link {
    font-size: 14px;
    color: red;
    text-decoration: none;
    line-height: 24px;
    cursor: pointer;
}

.confirm-patient-match-wrapper .modal-overlay {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    background: #000;
    opacity: .7;
    z-index: 5000;
}

.confirm-patient-match-wrapper .modal-prompt-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto !important;
    text-align: center;
}

.confirm-patient-match-wrapper .modal-prompt {
    margin-top: 5em;
    background: white;
    width: 300px;
    border: 1px solid black;
    border-radius: 5px;
    padding: 1em;
    z-index: 5002;
    box-sizing: border-box;
    text-align: center;
}

.confirm-patient-match-wrapper .modal-prompt .modal-statement {
    margin: 1em 0em;
    white-space: normal;
}

.confirm-patient-match-wrapper .modal-prompt .modal-action {
    display: block;
    border-top: 1px solid gray;
    cursor: pointer;
    margin-top: .5em;
    padding-top: .5em;
    text-align: center;
}

.confirm-patient-match-wrapper .modal-prompt .modal-action.modal-confirm {
    color: blue;
    white-space: normal;
}

.confirm-patient-match-wrapper .modal-prompt .modal-action.modal-cancel {
    color: red;
    white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/ConfirmPatientMatch/ConfirmPatientMatch.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;QAC1B,sBAAsB;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB","sourcesContent":[".confirm-patient-match-wrapper {\n    padding: 16px;\n    max-width: 450px;\n    margin: 0 auto;\n    line-height: 1.3;\n}\n\n.confirm-patient-match-wrapper .logos {\n    display: flex;\n    column-gap: 10px;\n    flex-direction: column;\n    padding: 8px 0 14px 0;\n}\n\n.confirm-patient-match-wrapper .logo-wrap {\n    display: flex;\n    align-items: center;\n    padding: 3px;\n    justify-content: center;\n}\n\n.confirm-patient-match-wrapper .logo-wrap img {\n    max-height: 34px;\n    max-width: 100%;\n    width: auto;\n}\n\n.confirm-patient-match-wrapper h2 {\n    font-weight: 500;\n    text-align: center;\n    margin: 6px 0;\n}\n\n.confirm-patient-match-wrapper .callout {\n    padding: 12px;\n    text-align: center;\n    border-radius: 6px;\n    background: var(--ce-orange-5);\n    margin-bottom: 20px;\n}\n\n.confirm-patient-match-wrapper .patient-info {\n    margin-bottom: 10px;\n    background: var(--ce-grey-5);\n    padding: 12px;\n    border-radius: 6px;\n}\n\n.confirm-patient-match-wrapper .patient-info .title {\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    padding-bottom: 12px;\n    justify-content: space-between;\n}\n\n.confirm-patient-match-wrapper .patient-info .title img {\n    max-height: 20px;\n}\n\n.confirm-patient-match-wrapper .patient-info .details {\n    background: #fff;\n    padding: 12px;\n    border-radius: 6px;\n}\n\n.confirm-patient-match-wrapper .patient-info .details > div {\n    padding-bottom: 3px;\n}\n\n.confirm-patient-match-wrapper .patient-info .details > div:last-of-type {\n    padding-bottom: 0;\n}\n\n.confirm-patient-match-wrapper .buttons {\n    padding-top: 10px;\n    display: flex;\n    justify-content: space-between;\n        flex-direction: column;\n    align-items: center;\n}\n\n.confirm-patient-match-wrapper button {\n    height: 44px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    padding: 4px 12px;\n}\n\n.confirm-patient-match-wrapper .confirm-button {\n    background: #000;\n    color: #fff;\n    cursor: pointer;\n    min-width: 250px;\n    display: flex;\n    justify-content: center;\n    /*display: table-cell;*/\n    /*text-align: center;*/\n}\n\n.confirm-patient-match-wrapper .cancel-button {\n    margin-bottom: 20px;\n    margin-right: 10px;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n}\n\n.confirm-patient-match-wrapper pre {\n    padding: 16px;\n    font-size: 10px;\n    background-color: lightgray;\n    border: solid 1px black;\n}\n\n.confirm-patient-match-wrapper .modal-container {\n    display: inline;\n    white-space: nowrap;\n    padding-left: 1em;\n    padding-right: 1em;\n}\n\n.confirm-patient-match-wrapper .modal-link {\n    font-size: 14px;\n    color: red;\n    text-decoration: none;\n    line-height: 24px;\n    cursor: pointer;\n}\n\n.confirm-patient-match-wrapper .modal-overlay {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    background: #000;\n    opacity: .7;\n    z-index: 5000;\n}\n\n.confirm-patient-match-wrapper .modal-prompt-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow-y: auto !important;\n    text-align: center;\n}\n\n.confirm-patient-match-wrapper .modal-prompt {\n    margin-top: 5em;\n    background: white;\n    width: 300px;\n    border: 1px solid black;\n    border-radius: 5px;\n    padding: 1em;\n    z-index: 5002;\n    box-sizing: border-box;\n    text-align: center;\n}\n\n.confirm-patient-match-wrapper .modal-prompt .modal-statement {\n    margin: 1em 0em;\n    white-space: normal;\n}\n\n.confirm-patient-match-wrapper .modal-prompt .modal-action {\n    display: block;\n    border-top: 1px solid gray;\n    cursor: pointer;\n    margin-top: .5em;\n    padding-top: .5em;\n    text-align: center;\n}\n\n.confirm-patient-match-wrapper .modal-prompt .modal-action.modal-confirm {\n    color: blue;\n    white-space: normal;\n}\n\n.confirm-patient-match-wrapper .modal-prompt .modal-action.modal-cancel {\n    color: red;\n    white-space: normal;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
